import React, { useRef, useState } from 'react'
import { Menu, MenuButton, MenuList, MenuItem, Button } from "@chakra-ui/react"
import { Link, useHistory } from 'react-router-dom'
import { RiMore2Line } from 'react-icons/ri'

export const Dropdown = ( { track } ) => {
  const { ar, al } = track
  const [show, setShow] = useState( false )
  const alRef = useRef( null )
  const artistRef = useRef( null )
  const history = useHistory()

  // eslint-disable-next-line
  const goToArtistOrAlbum = () => {
    if ( ar ) {
      // history.pathname.push( `/artists/${ar[0].id}` )
      history.replace( `/artists/${ar && ar[0].id}` )
      // console.log( ar, "ar" )
    } else if ( track && al ) {
      history.location.push( `/album/${al.id}` )
    }
  }
  // console.log( history, "history", ar )
  return (
    <Menu closeOnSelect={true}>
      <MenuButton
        as={Button}
        // isOpen={show}
        // closeOnBlur={true}
        px={0}
        minWidth={1}
        bg="transparent"
        _hover={{ bg: "transparent" }}
        _active={{ bg: "transparent" }}
        onClick={() => setShow( !show )}>
        <RiMore2Line />
      </MenuButton>
      {track && <MenuList
        bg="brand.svtPlayBlack"
        color="#eee"
        _focus={{ outline: "none", boxShadow: "outline" }}
      // closeOnBlur={true}
      >
        <MenuItem ref={artistRef}>
          {ar
            ? <Link to={`/artists/${ar[0].id}`}>
              Go to Artist
            </Link>
            : <span aria-disabled="true">
              Go to Artist
            </span>
          }
        </MenuItem>
        <MenuItem
          ref={alRef}
          onClick={() => setShow( !show )}>
          {al ? <Link to={`/album/${al.id}`}>
            Go to Album
          </Link>
            : <span aria-disabled="true">
              Go to Album
            </span>
          }
        </MenuItem>
        <MenuItem onClick={() => alert( "Psych!" )}>
          Create a Copy
        </MenuItem>
      </MenuList>
      }
    </Menu>
  )
}